export enum InfographicSize {
    RATIO_16_9 = '16:9',
    RATIO_9_16 = '9:16',
    RATIO_1_1 = '1:1',
    A4 = 'A4',
    A3 = 'A3',
    POSTER = 'POSTER',
}